export default theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(2)
  },
  formControl: {
    width: "100%",
    margin: `${theme.spacing(2)}px 0`
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  },
  fieldError: {
    color: theme.palette.danger.main,
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(1)
  }
});
